import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m31.298 14.712-1.4-1.412a2.4 2.4 0 0 0-3.395 0l-8.777 8.776a3.2 3.2 0 0 0-.875 1.635l-.832 4.168a.6.6 0 0 0 .543.719.6.6 0 0 0 .119-.012l4.168-.834a3.2 3.2 0 0 0 1.635-.875l8.777-8.777a2.36 2.36 0 0 0 .043-3.395Zm-9.906 11a1.6 1.6 0 0 1-.818.437l-2.7.582.54-2.7a1.6 1.6 0 0 1 .437-.818l5.72-5.713 2.539 2.538-5.712 5.671Zm8.776-8.731-1.931 1.931-2.539-2.542 1.931-1.931a.8.8 0 0 1 1.132 0l1.407 1.408a.8.8 0 0 1 0 1.131ZM11.157 15.8a6.4 6.4 0 1 0-6.359-6.4 6.4 6.4 0 0 0 6.359 6.4m0-11.2a4.8 4.8 0 1 1-4.8 4.8 4.805 4.805 0 0 1 4.8-4.8M13.628 27H1.734a.134.134 0 0 1-.133-.135A7.074 7.074 0 0 1 8.667 19.8h5.065a6.9 6.9 0 0 1 2.693.563.89.89 0 0 0 .949-.2.776.776 0 0 0-.227-1.257 8.7 8.7 0 0 0-3.41-.707h-5.07a8.663 8.663 0 0 0-8.669 8.675A1.74 1.74 0 0 0 1.734 28.6h11.9a.774.774 0 0 0 .773-.773v-.053a.8.8 0 0 0-.778-.774Z"
    }, null, -1)
  ])))
}
export default { render: render }